import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { fetchAllReferenceData } from '../../../../../../utils/employee/fetchAllReferenceData';
import { getDynamicLeaveConfig } from '../../../../../../utils/employee/dynamicLeaveHelper';
import { buildTemplateWorksheet } from '../../../../../../utils/employee/buildWorksheet';

export const generateDownloadLeaveTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  
  // ADDED: Fetch refs and dynamic config
  const refs = await fetchAllReferenceData(); 
  const dynamicLeaveSection = await getDynamicLeaveConfig();

  // MODIFIED: Swapped hardcoded logic for buildTemplateWorksheet
  await buildTemplateWorksheet(
    workbook,
    "EmployeeLeave",
    dynamicLeaveSection,
    refs,
    {
      prependFields: [
        { key: "employeeId", label: "EmployeeId", width: 25, sampleValue: "<EMP1234>" },
        { key: "employeeName", label: "EmployeeName", width: 30, sampleValue: "<DELA CRUZ, JUAN>" },
      ],
    }
  );

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, 'Employee_Leave_Template.xlsx');
};